import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

import TextEditorButton from './text-editor-button';
import styles from './text-editor-upload-button.scss';
import { handleEnterKeyUp } from '../../services/accessibility';

export class TextEditorUploadButton extends Component {
  handleMouseDown = event => {
    event.preventDefault();
  };

  handleChange = event => {
    if (event.target.files[0]) {
      this.props.onFileChange(event);
    }
    this.form.reset();
  };

  setForm = form => {
    this.form = form;
  };

  triggerInputClick = () => {
    this.input && this.input.click();
  };

  setInput = input => {
    this.input = input;
  };

  render() {
    const {
      isDisabled,
      onFileChange, // eslint-disable-line no-unused-vars
      ...otherProps
    } = this.props;

    return (
      <div className={classNames(styles.button, 'text-editor-upload-button')}>
        <TextEditorButton isDisabled={isDisabled} {...otherProps} onKeyUp={handleEnterKeyUp(this.triggerInputClick)}>
          <form ref={this.setForm}>
            <input
              ref={this.setInput}
              className={styles.input}
              type="file"
              onChange={this.handleChange}
              accept="image/*"
              disabled={isDisabled}
              onMouseDown={this.handleMouseDown}
              tabIndex="-1"
            />
          </form>
        </TextEditorButton>
      </div>
    );
  }
}

TextEditorUploadButton.propTypes = {
  onFileChange: PropTypes.func,
  isDisabled: PropTypes.bool,
};

export default TextEditorUploadButton;



// WEBPACK FOOTER //
// ./app/components/text-editor/text-editor-upload-button.js